export default {
    _targets: null,
    _togglepages: null,
    _togglepageClass: null,
    _targetClass: null,

    init() {
        this._togglepages = document.querySelectorAll('[data-togglepage]');
        this._targets = document.querySelectorAll('[data-togglepage-target]');
        
        if (!this._togglepages.length || !this._targets.length) {
            return;
        }

        // For each button, add event listener
        for (const button of this._togglepages) {
            button.addEventListener('click', () => {
                this._togglepageClass = button.classList[0] + '--active';

                //custom style for spotpris graph
                if(!(button.classList.contains(this._togglepageClass)) && button.getAttribute('data-togglepage-grp') == "graph"){
                    let formElm = document.querySelector('.graph__formSection');
                    if(formElm){
                        if(button.getAttribute('data-togglepage') == "country"){
                            formElm.style.display = "none";
                        }else{
                            formElm.style.display = "block";
                        }
                    }
                }
                
                for (const btn of this._togglepages) {
                    btn.classList.remove(this._togglepageClass)
                }

                for (const target of this._targets) {
                    const targetClass = target.classList[0] + '--active';
                    
                    if ((target.getAttribute('data-togglepage-target') === button.getAttribute('data-togglepage')) && (target.getAttribute('data-togglepage-grp') === button.getAttribute('data-togglepage-grp'))) {
                        target.classList.add(targetClass);
                    }
                    else {
                        if ((target.getAttribute('data-togglepage-grp') === button.getAttribute('data-togglepage-grp')) && target.classList.contains(targetClass)) {
                            target.classList.remove(targetClass);
                        }
                    }
                }

                button.classList.add(this._togglepageClass);
            });
        }
    }
}